<template>
  <div class="error-page">
    <h1 class="error-page-icon">
      {{ status }}
      <svg viewBox="0 0 48 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" fill="#002956" clip-rule="evenodd" d="M23.9978 11.5097C15.4022 11.5097 8.80078 7.99515 3.27151 0.815003C2.66759 0.0326979 1.78062 -0.298033 0.80634 0.326857C0.323092 0.636388 0 1.12665 0 1.65455C0 2.26142 0.299736 2.70134 0.657862 3.2022C6.59141 11.4975 14.0108 16 23.9622 16C34.0926 16 41.4103 11.5108 47.3544 3.18259C47.7214 2.67006 48 2.27573 48 1.65402C48 1.09326 47.6335 0.575436 47.1008 0.271736C46.1593 -0.265172 45.3046 0.0793394 44.7268 0.815003C39.1981 7.99621 32.5244 11.5097 23.9978 11.5097Z" />
      </svg>
    </h1>
    <p class="error-page-title" v-text="title" />
    <p class="error-page-subtitle" v-if="status === 404">
      Чтобы найти нужную информацию, воспользуйтесь <a @click.prevent="$f.toggleSearch">поиском</a>
      <br>или перейдите на <a href="/">главную страницу</a>
    </p>
  </div>
</template>

<script>
import pageMetaMixin from '@/mixins/page-meta-mixin';

export default {
  name: 'error-page',
  metaInfo() {
    return this.getPageMeta({ pageTitle: `Ошибка ${this.status}` });
  },
  mixins: [pageMetaMixin],
  props: {
    status: {
      type: [Number, String],
      default: 404,
    }
  },
  computed: {
    title() {
      switch (Number(this.status)) {
        //case 404: return 'Такой страницы не существует';
        default: return 'Такой страницы не существует';
      }
    }
  },
};
</script>

<style lang="scss">
.error-page {
  max-width: 280px;
  margin: 80px auto 120px;
  text-align: center;
  h1 {
    width: 120px;
    height: 120px;
    border-radius: 50%;
    background-color: $blue_8;
    margin: 0 auto 16px;
    color: $blue;
    padding: 36px 0 0;
    font-weight: 300;
    font-size: 40px;
    line-height: 48px;
    letter-spacing: 5px;
    display: flex;
    flex-direction: column;
    svg {
      width: 36px;
      height: 12px;
      margin: 0 auto;
    }
  }
  &-title {
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    margin: 24px 0 4px;
  }
  &-subtitle {
    font-size: 14px;
    line-height: 20px;
  }
  a {
    color: $blue;
  }
}

@include breakpoint("desktop") {
  .error-page {
    max-width: 500px;
    margin: 120px auto 160px;
    h1 {
      width: 160px;
      height: 160px;
      margin: 0 auto 16px;
      padding: 44px 0 0;
      font-size: 56px;
      line-height: 64px;
      svg {
        width: 48px;
        height: 16px;
      }
    }
    &-title {
      font-size: 20px;
      line-height: 28px;
      margin: 32px 0 16px;
    }
    &-subtitle {
      font-size: 16px;
      line-height: 24px;
    }
  }
}
</style>
